<template>
    <v-container id="contact-container" fluid>
        <ContactBanner></ContactBanner>
        <ContactMain></ContactMain>
        <ContactMessageUs></ContactMessageUs>
    </v-container>
</template>
<script>
import ContactBanner from '../components/ui/ContactBanner.vue'
import ContactMain from '../components/layout/ContactMain.vue'
import ContactMessageUs from '../components/layout/ContactMessageUs.vue'
export default {
    name: 'Contact',
    components: {
        ContactBanner,
        ContactMain,
        ContactMessageUs
    }
};
</script>
<style scoped>
</style>
